import tickerNames from './ticker-names';

const fetchExamplePortfolio = (modelEndpoint) => (dispatch, getState) => {

  const { clientEmail, token, wtRegion, windowDefaultPortfolio, examplePortfolioName } = getState();

  const a = document.getElementById("example-template-xlsx") || document.createElement("a");
  document.body.appendChild(a);
  a.setAttribute("id", "example-template-xlsx");
  a.setAttribute("style","display: none");
  a.href = "/-/media/us-media-files/advisor-solutions/digital-portfolio-developer/xls/template.xlsx"
  a.download = "template.xlsx";

  const url = `${process.env.REACT_APP_API_URL}/modelportfolio/${modelEndpoint}/`;
  fetch(`${url}?clientEmail=${clientEmail}&wtRegion=${wtRegion}`, { 
    headers: {
      Authorization: token &&
        `Token ${token}`,
    },
  })
    .then(d => {
      if(d.status >= 400){
        return;
      }
      if(modelEndpoint === 'example'){
        return d.json().then(portfolio => {
          dispatch({ type: 'SET_DEFAULT_PORTFOLIO', portfolio })

          // either load this example portfolio, or send windowDP to tickerNames
          // tickerNames will load it and make it the new default portfolio
          //if (loadExamplePortfolio) {
            if (windowDefaultPortfolio.length) {
              const portName = examplePortfolioName ? examplePortfolioName : 'Example Portfolio';
              dispatch(tickerNames(windowDefaultPortfolio, portName))
            } else {
              // dispatch({ type: 'LOAD_PORTFOLIO', portfolio })
            }
          //}
        })
      }
      if(modelEndpoint === 'example_template'){
        return d.blob().then(blob => {
          const url = window.URL.createObjectURL(blob);
          if(window.navigator.msSaveOrOpenBlob){
            a.addEventListener('click',() => window.navigator.msSaveOrOpenBlob(blob, "template.xlsx"));
          } else {
            a.href = url;
            a.download = "template.xlsx";
          }
        })
      }
    })
    .catch(error => {
      console.error(error);
    });
};

const downloadExampleTemplate = (dispatch, getState) => {
  document.getElementById("example-template-xlsx").click();
};

export {
  fetchExamplePortfolio,
  downloadExampleTemplate
}


// WEBPACK FOOTER //
// ./src/actions/query-api/example-portfolio.js